import React from "react";
import {
    Column,
    DataGrid,
    Paging,
    Pager,
    HeaderFilter,
    FilterRow,
    FormItem,
} from 'devextreme-react/data-grid';
import { Editing } from "devextreme-react/scheduler";
import PaginaToolbar from '../components/PaginaToolbar';
import { criarUnidadeFiscal } from "../DataSources";
import UserInfo from "../UserInfo";
import uiInfo from "../ui-info";

export default class UnidadeFiscalBox extends React.Component {
    constructor() {
        super();
        this.initNewRow = this.initNewRow.bind(this);
    }

    render() {
        return (
            <div className={'content-block dx-card responsive-paddings'}>
                <PaginaToolbar titulo="Unidades Fiscais">
                    <DataGrid
                        dataSource={criarUnidadeFiscal()}
                        showBorders={true}
                        rowAlternationEnabled={true}
                        remoteOperations={true}
                        focusedRowEnabled={true}
                        wordWrapEnabled={true}
                        onInitNewRow={this.initNewRow}>
                        <HeaderFilter visible={true} />
                        <FilterRow visible={true} />
                        <Editing mode={"row"} allowAdding={false} allowUpdating={true} allowDeleting={true} useIcons={true} />
                        <Column
                            type="buttons"
                            fixed={true}
                            fixedPosition={"left"}
                            buttons={["edit", "delete"]}
                        />
                        <Column dataField={'id'} caption={"#"} width={'150'} allowEditing={false} />
                        <Column dataField={'prefeituraId'} caption={"Prefeitura"} visible={false}>
                            <FormItem visible={false}></FormItem>
                        </Column>
                        <Column dataField={'descricao'} caption={"Descrição"} />
                        <Column
                            dataField={'dataInicioVigencia'}
                            dataType={'date'}
                            caption={"Início Vigência"}
                            editorType={"dxDateBox"}
                            editorOptions={{ useMaskBehavior: true }} />
                        <Column
                            dataField={'dataFimVigencia'}
                            dataType={'date'}
                            caption={"Fim Vigência"}
                            editorType={"dxDateBox"}
                            editorOptions={{ useMaskBehavior: true }} />
                        <Column dataField={'valor'}
                            caption={"Valor"}
                            dataType={"number"}
                            editorType={"dxNumberBox"}
                            format={"#,##0.000000" }
                            editorOptions={{ format: "#,##0.000000" }} />
                        <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                        <Pager
                            showPageSizeSelector={true}
                            allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                        />
                    </DataGrid>
                </PaginaToolbar>
            </div>
        );
    }

    initNewRow(e) {
        e.data.prefeituraId = UserInfo.getPrefeitura();
    }

}
